export default __webpack_public_path__ + "static/media/roadPadi.f4f6dadb.svg";